export default __webpack_public_path__ + "static/char-s-sp02-jp-7fcf3e85dd51bd89e257c105b7f1f9c7.png";